import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {BehaviorSubject, Observable, catchError} from 'rxjs';
import { DataService } from '../data.service';
import {Carrier, CarrierApprovalInformationEntity} from './carrier';

@Injectable({
  providedIn: 'root'
})
export class CarrierService extends DataService {

  private baseURI = this.apiUri + '';
  carrierApprovalInformationEntity: CarrierApprovalInformationEntity[] = [new CarrierApprovalInformationEntity('',
    '', '', '', '', '', '', '', '', '', '', '', ''
  , '', '', '', '', '', '', '','','')];
  carrierInit: Carrier = new Carrier('', '', '', '', '', '', '',
    '', '', '', '', '', '', '',
    '', '', '', '', '', '', '',
    '', '', '', '', this.carrierApprovalInformationEntity, '', '');
  controlKeyInit: any = {};
  rateBidcyclesInit: any = {};
  private carrierSource = new BehaviorSubject<Carrier>(this.carrierInit);
  private controlKeySource = new BehaviorSubject<any>(this.controlKeyInit);
  private controlFRTKeySource = new BehaviorSubject<any>(this.controlKeyInit);
  private rateBidcycleSource = new BehaviorSubject<any>(this.rateBidcyclesInit);
  private scacFRTURI = '/carrier/scac/FRT/list';
  currentCarrier = this.carrierSource.asObservable();
  controlKey = this.controlKeySource.asObservable();
  controlFRTKey = this.controlFRTKeySource.asObservable();
  rateBidcycle = this.rateBidcycleSource.asObservable();

  constructor(http: HttpClient) {
    super(http);
  }

  // Purpose of this function is to get List of all CarrierList by ScacExt
  getAllCarrierListByBusinessType(businessType: string): Observable<Carrier[]> {
    this.setUri(this.baseURI + '/carrier/list/');
    let params: HttpParams = new HttpParams();
    params = params.append('businessType', businessType);
    return this.get({params}).pipe(catchError(this.handleError));
  }

  // Purpose of this function is to get List of all Carriers by business Type List(HHG or HHG & FRT or FRT) and Carrier status
  getAllCarrierListByBusinessTypeAndStatus(businessTypeList: any, status: string): Observable<Carrier[]> {
    this.setUri(this.baseURI + '/carrier/scacList/');
    let params: HttpParams = new HttpParams();
    params = params.append('businessTypeList', businessTypeList);
    params = params.append('status', status);
    return this.get({params}).pipe(catchError(this.handleError));
  }



  // Purpose of this function is to get List of all Carriers as they enter partial scaccode
  getAllCarrierScacCodeList(scac: string, businessType: string): Observable<Carrier[]> {
    this.setUri(this.baseURI + '/carrier/scacunique/');
    let params: HttpParams = new HttpParams();
    params = params.append('scac', scac);
    params = params.append('businessType', businessType);
    return this.get({params}).pipe(catchError(this.handleError));
  }

  // Purpose of this function is to get List of all Carriers as they enter partial scacname
  getAllCarrierScacNameList(scacname: string, businessType: string): Observable<Carrier[]> {
    this.setUri(this.baseURI + '/carrier/scacnameunique/');
    let params: HttpParams = new HttpParams();
    params = params.append('scacName', scacname);
    params = params.append('businessType', businessType);
    return this.get({params}).pipe(catchError(this.handleError));
  }

  // Purpose of this function is to get all Carrier users based on SCAC code
  getCarrierByScacCode(scac: string, businessType: string): Observable<Carrier> {
    this.setUri(this.baseURI + '/carrier/scac/');
    let params: HttpParams = new HttpParams();
    params = params.append('scac', scac);
    params = params.append('businessType', businessType);
    return this.get({params}).pipe(catchError(this.handleError));
  }

  // Purpose of this function is to get all Carrier users based on SCAC Name
  getCarrierByScacName(scacname: string, businessType: string): Observable<Carrier[]> {
    this.setUri(this.baseURI + '/carrier/scacname/');
    let params: HttpParams = new HttpParams();
    params = params.append('scacName', scacname);
    params = params.append('scacext', businessType);
    return this.get({params}).pipe(catchError(this.handleError));
  }

  // Purpose of this function is to get the carrier based on carrierId
  getCarrierByCarrierId(carrierId: number): Observable<any> {
    return this.http.get(this.apiUri + '/carrier/' + carrierId + '/carrierid');
  }

  // Purpose of this function is to get List of all HHG carriers for a RFSP
  getAllRfspsCarriers(carrierId: number): Observable<any> {
    return this.http.get(this.apiUri + '/rfspscarriers/' + carrierId + '/carrierid');
  }

  getAllRfspsCarriersIff(carrierId: number): Observable<any> {
    return this.http.get(this.apiUri + '/rfspscarriers/' + carrierId + '/carrierid/' + 'IFF' + '/shipmentType');
  }

  // Purpose of this function is to delete Carrier Users
  deleteCarrierUser(carrierId: number): Observable<any> {
    this.setUri(this.baseURI + '/carrier/deletecarrier');
    return this.update(carrierId);
  }

  getNonUseTSP(): Observable<any> {
    return this.http.get(this.apiUri + '/carrier/nonusetsp');
  }

  // using this to avoid local storage
  setCarrierObservable(carrier: Carrier) {
    this.carrierSource.next(carrier);
  }

  // using this to avoid local storage
  getCarrierObservable() {
    return this.currentCarrier;
  }

  // using this to avoid local storage
  setControlKeyObservable(controlKey: any) {
    this.controlKeySource.next(controlKey);
  }

  // using this to avoid local storage
  getControlKeyObservable() {
    return this.controlKey;
  }
  // using this to avoid local storage
  setFRTControlKeyObservable(controlKey: any) {
    this.controlFRTKeySource.next(controlKey);
  }
  // using this to avoid local storage
  getRateBidCycleId() {
    return this.rateBidcycle;
  }
  setRateBidCycleId(rateBidCycleId: any) {
    this.rateBidcycleSource.next(rateBidCycleId);
  }

  // using this to avoid local storage
  getFRTControlKeyObservable() {
    return this.controlFRTKey;
  }
 // Purpose of this function is to get List of all HHG Carriers (Small version of Carrier Entity)
   getAllSmallCarrierListByBusinessTypeAndStatus(businessTypeList: any, status: string): Observable<any> {
    return this.http.get(this.baseURI + '/smallHHGCarrier/scacList');
  }

  getFRTScac() {
    return this.http.get<any>(this.baseURI + '/carrier/scac/FRT/list');
  }

}
